import { render } from "./MenusForm.vue?vue&type=template&id=65789e9e"
import script from "./MenusForm.vue?vue&type=script&lang=js"
export * from "./MenusForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__